const { q } = require('../helpers.js');

export const divWrapper = q('#divWrapper');
export const divScrollbar = q('#divScrollbar');
export const lblTermsSubject = q('#lblTermsSubject');
export const lblTermsText = q('#lblTermsText');
export const btnTermsReject = q('#btnTermsReject');
export const btnTermsAccept = q('#btnTermsAccept');
export const btnTermsExpand = q('#btnTermsExpand');
export const chkAdult = q('#chkAdult');
export const chkDisclaimer = q('#chkDisclaimer');
export const lnkDisclaimer = q('#lnkDisclaimer');
export const chkProductDetails = q('#chkProductDetails');
export const lnkProductDetails = q('#lnkProductDetails');
export const chkConditions = q('#chkConditions');
export const lnkConditions = q('#lnkConditions');
export const chkPersonalData = q('#chkPersonalData');
export const btnTermsNext = q('#btnTermsNext');